import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthPublicGuard implements CanActivate, CanActivateChild {
  constructor(
    private authService: AuthService,
    private msalAuthService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router
  ) { }

  private async validate(): Promise<boolean | UrlTree> {
    return await new Promise(resolve => {
      this.msalBroadcastService.inProgress$
        .pipe(
          filter((status: InteractionStatus) => status === InteractionStatus.None),
        )
        .subscribe(res => {
          const account = this.msalAuthService.instance.getActiveAccount() || this.msalAuthService.instance.getAllAccounts()[0];
          if (account) {
            resolve(this.router.parseUrl('/catalog'));
          }
          else {
            resolve(true);
          }
        })
    })
    // const authed = await this.authService.getAccessToken();
    // if (authed) return this.router.parseUrl('/dashboard');
    // return true;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean {
    return this.validate();
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean {
    return this.validate();
  }
}
